import { combineReducers } from 'redux';
import {
  FETCH_ALGO_STATUS_REQUEST,
  FETCH_ALGO_STATUS_SUCCESS,
  FETCH_ALGO_STATUS_FAILURE,
} from '../constants/ActionTypes';

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGO_STATUS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGO_STATUS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGO_STATUS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const status = combineReducers({
  selected,
});

export default status;
